module.exports = __webpack_public_path__ + "static/helloworld.cbde7c81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/helloworld.jpg
// module id = 25
// module chunks = 35783957827783 114276838955818 164155623112449 263791100135453